/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Else, If, Then } from "react-if";
import styled from "styled-components";
import { FlexContainer, theme } from "@nordcloud/gnui";
import { useAuth0 } from "~/services";
import { DropdownWrap } from "./UserDropdown";

const StyledImage = styled.img`
  margin-right: ${theme.spacing.spacing01};
  height: 2.4rem;
  border-radius: 50%;
`;

export function User() {
  const { user } = useAuth0();

  return (
    <DropdownWrap>
      <FlexContainer>
        <If condition={user?.picture}>
          <Then>
            <StyledImage alt="avatar" src={user?.picture} />
          </Then>
          <Else>
            <UserImg />
          </Else>
        </If>
      </FlexContainer>
    </DropdownWrap>
  );
}

export function UserImg() {
  return (
    <svg width="40" height="40" fill="none">
      <circle cx="20" cy="20" r="20" />
      <path
        d="M19.9997 25.2148C15.2963 25.2148 11.4697 29.0414 11.4697 33.7449C11.4697 34.017 11.4831 34.2861 11.5083 34.5516C14.0574 36.0449 16.967 36.8421 19.9997 36.8421C23.0325 36.8421 25.9421 36.0449 28.4912 34.5516C28.5164 34.2858 28.5298 34.017 28.5298 33.7449C28.5298 29.0414 24.7032 25.2148 19.9997 25.2148Z"
        fill="#7A7A94"
      />
      <path
        d="M31.9095 8.09082C28.7285 4.9098 24.4992 3.1579 20.0003 3.1579C15.5014 3.1579 11.2722 4.9098 8.09113 8.09082C4.9101 11.2718 3.1582 15.5011 3.1582 20C3.1582 24.4986 4.9101 28.7282 8.09113 31.9092C8.54395 32.3623 9.01886 32.785 9.51203 33.179C9.73278 29.0435 12.3567 25.5358 16.009 24.0299C14.0014 22.721 12.6715 20.4562 12.6715 17.886C12.6715 13.8448 15.9591 10.5572 20.0003 10.5572C24.0415 10.5572 27.3292 13.8448 27.3292 17.886C27.3292 20.4562 25.9992 22.721 23.9916 24.0299C27.644 25.5358 30.2678 29.0435 30.4886 33.179C30.9818 32.785 31.4567 32.362 31.9095 31.9092C35.0905 28.7282 36.8424 24.4986 36.8424 20C36.8424 15.5011 35.0905 11.2718 31.9095 8.09082Z"
        fill="#7A7A94"
      />
      <path
        d="M25.3549 17.886C25.3549 14.9329 22.9525 12.5308 19.9997 12.5308C17.0469 12.5308 14.6445 14.9332 14.6445 17.886C14.6445 20.8388 17.0469 23.2411 19.9997 23.2411C22.9525 23.2411 25.3549 20.8388 25.3549 17.886Z"
        fill="#7A7A94"
      />
    </svg>
  );
}
